import { useEffect, useState } from "react";
import TrackService from "../../services/ArtService";
import LinkedText from "../LinkedText";
import { faSpotify, faApple, faYoutube } from "@fortawesome/free-brands-svg-icons";

export default function TrackTable() {
    const [tracks, setTracks] = useState([]);
    const [isNarrowScreen, setIsNarrowScreen] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const fetchTracks = async () => {
            try {
                const data = await TrackService.getAllTracks();
                setTracks(data);
            } catch (error) {
                console.error("Failed to fetch tracks:", error);
            }
        };

        fetchTracks();
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setIsNarrowScreen(window.innerWidth <= 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div>
            <table>
                <thead>
                <tr>
                    <th>Song</th>
                    <th>Genre</th>
                    {isNarrowScreen ? (
                        <th>Links</th>
                    ) : (
                        <>
                            <th>Spotify</th>
                            <th>Apple Music</th>
                            <th>YouTube</th>
                        </>
                    )}
                </tr>
                </thead>
                <tbody>
                {tracks.map((track) => (
                    <tr key={track.id}>
                        <td>{track.title}</td>
                        <td>{track.genre}</td>
                        {isNarrowScreen ? (
                            <td>
                                {track.spotify_link && (
                                    <>
                                        <LinkedText text={"Listen"} href={track.spotify_link} icon={faSpotify} customBgColor={"#1DB954"}/>
                                        <br />
                                    </>
                                )}
                                {track.apple_music_link && (
                                    <>
                                        <LinkedText text={"Listen"} href={track.apple_music_link} icon={faApple} customBgColor={"#FF4E6B"}/>
                                        <br />
                                    </>
                                )}
                                {track.youtube_link && (
                                    <LinkedText text={"Listen"} href={track.youtube_link} icon={faYoutube} customBgColor={"#FF0000"}/>
                                )}
                            </td>
                        ) : (
                            <>
                                <td>
                                    {track.spotify_link && (
                                        <LinkedText text={"Listen"} href={track.spotify_link} icon={faSpotify} customBgColor={"#1DB954"}/>
                                    )}
                                </td>
                                <td>
                                    {track.apple_music_link && (
                                        <LinkedText text={"Listen"} href={track.apple_music_link} icon={faApple} customBgColor={"#FF4E6B"}/>
                                    )}
                                </td>
                                <td>
                                    {track.youtube_link && (
                                        <LinkedText text={"Listen"} href={track.youtube_link} icon={faYoutube} customBgColor={"#FF0000"}/>
                                    )}
                                </td>
                            </>
                        )}
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
}
